export default {
    CORE: "CORE",
    BPM: "BPM",
    COLD: "COLD",
    DASHBOARDS: "DASHBOARDS",
    CONNECT: "CONNECT",
    EXPORTER: "EXPORTER",
    E_FORMS: "E_FORMS",
    ENTERPRISE_SEARCH: "ENTERPRISE_SEARCH",
    FAX_INTEGRATION: "FAX_INTEGRATION",
    HSM: "HSM",
    PRINT_TO_DOCFINITY: "PRINT_TO_DOCFINITY",
    API: "API",
    RECORDS_MANAGEMENT: "RECORDS_MANAGEMENT",
    GATEWAY: "GATEWAY",
    CLOUD: "CLOUD",
    STARTUP: "STARTUP"
};
